// extracted by mini-css-extract-plugin
export var image = "cp_dr";